// extracted by mini-css-extract-plugin
export default {"PriceButton__button":"PriceButton_PriceButton__button__ODFjZ","PriceButton__buttonArrow":"PriceButton_PriceButton__buttonArrow__NWIyO"};